import _createForOfIteratorHelper from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.find-last-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import linkDrawer from '@/views/cardSystem/customer/components/linkDrawer.vue';
import autoComponents from './register.js';
import draggable from 'vuedraggable';
import { getComponents, update, save, saveCategory, getCategory, getWidgetValue, getChannelList, generateTemplate, getTemplateList, movieBanner, getSystemMenus, getUnionModule, getBookCategoryList, getCustomerPackage, getLog, getWidgetList } from './api';
import { getFileInfo } from '@/components/upload/index';
import { getCustomerAccountOne, getUrl } from '@/views/cardSystem/customer/api/index.js';
import { isEmpty, guid, dataURLToBlob, scrollToError } from '@/utils';
import mixin from './mixin.js';
import getPageTitle from '@/utils/get-page-title';
import html2Canvas from 'html2canvas';
import { uploadFile } from '@/components/upload/upload';
import uploadFiles from '@/components/upload/uploadFile.vue';
export default {
  name: 'customLayout',
  mixins: [mixin],
  props: {
    propInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: _objectSpread({
    linkDrawer: linkDrawer,
    draggable: draggable,
    uploadFiles: uploadFiles,
    editCustomer: function editCustomer() {
      return import('@/views/cardSystem/customer/editCustomer.vue');
    }
  }, autoComponents),
  beforeRouteEnter: function beforeRouteEnter(to, _, next) {
    to.meta.title = to.query.category_id ? '功能菜单装修' : '商城首页装修';
    document.title = getPageTitle(to.meta.title);
    next();
  },
  data: function data() {
    return {
      isEmpty: isEmpty,
      style_id: '',
      home_style: '',
      background_config: {},
      //背景配置信息
      is_channel: false,
      //客户级是否需要继承渠道 原样传给后端即可
      info: {},
      //存储渠道 & 客户信息
      template_config_id: '',
      //模板ID备选值
      configLoading: false,
      releaseLoading: false,
      // left start
      tabList: [],
      tabListFlat: [],
      //扁平化后的组件列表
      oldActiveTab: '',
      activeTab: '',
      activeLeftData: {},
      leftFilterArr: ['position', 'switch_account', 'search_shop', 'aggregate_search_shop', 'box_position_search_switch', 'five_in_one', 'system_drawer'],
      // 左侧面板禁止拖拽元素
      panelForm: {
        name: '',
        page: 1,
        page_size: 20
      },
      //左侧面板搜索表单
      panelCount: 0,
      // left end

      // center start
      layoutList: [],
      // 拖拽区内所有组件集合
      bottomData: {},
      // 底部导航数据,不参与拖拽 & 删除等, 所以数据抽离出来
      bottomHeight: '0px',
      startX: 0,
      noPlate: false,
      // center end

      noConfigList: ['search_shop'],
      //右侧配置区域 - 暂时没有配置项的组件
      filterList: [{
        key: 'position',
        mutual_keys: ['five_in_one'],
        //互斥的key
        isShow: function isShow(allLayoutList) {
          var _this = this;
          return allLayoutList.find(function (i) {
            return [].concat(_toConsumableArray(_this.mutual_keys), [_this.key]).includes(i.key);
          });
        }
      }, {
        key: 'switch_account',
        mutual_keys: ['five_in_one', 'system_drawer'],
        //互斥的key
        isShow: function isShow(allLayoutList) {
          var _this2 = this;
          return allLayoutList.find(function (i) {
            return [].concat(_toConsumableArray(_this2.mutual_keys), [_this2.key]).includes(i.key);
          });
        }
      }, {
        key: 'system_drawer',
        mutual_keys: ['five_in_one', 'switch_account'],
        //互斥的key
        isShow: function isShow(allLayoutList) {
          var _this3 = this;
          return allLayoutList.find(function (i) {
            return [].concat(_toConsumableArray(_this3.mutual_keys), [_this3.key]).includes(i.key);
          });
        }
      }, {
        key: 'search_shop',
        mutual_keys: ['five_in_one'],
        //互斥的key
        isShow: function isShow(allLayoutList) {
          var _this4 = this;
          return allLayoutList.find(function (i) {
            return ['aggregate_search_shop'].concat(_toConsumableArray(_this4.mutual_keys), [_this4.key]).includes(i.key);
          });
        }
      }, {
        key: 'aggregate_search_shop',
        mutual_keys: ['five_in_one'],
        //互斥的key
        isShow: function isShow(allLayoutList) {
          var _this5 = this;
          return allLayoutList.find(function (i) {
            return ['search_shop'].concat(_toConsumableArray(_this5.mutual_keys), [_this5.key]).includes(i.key);
          });
        }
      }, {
        key: 'five_in_one',
        mutual_keys: ['position', 'switch_account', 'search_shop', 'aggregate_search_shop', 'system_drawer'],
        //互斥的key
        isShow: function isShow(allLayoutList) {
          var _this6 = this;
          return allLayoutList.find(function (i) {
            return [].concat(_toConsumableArray(_this6.mutual_keys), [_this6.key]).includes(i.key);
          });
        }
      }, {
        key: 'banner_new',
        isShow: function isShow(allLayoutList) {
          var _this7 = this;
          return allLayoutList.find(function (i) {
            return i.key === _this7.key;
          });
        }
      }, {
        key: 'gift_pack_card',
        isShow: function isShow(allLayoutList) {
          var _this8 = this;
          return allLayoutList.find(function (i) {
            return i.key === _this8.key;
          });
        }
      }, {
        key: 'bottom',
        isShow: function isShow(allLayoutList) {
          var _this9 = this;
          return allLayoutList.find(function (i) {
            return i.key === _this9.key;
          });
        }
      }, {
        key: 'run_notice',
        isShow: function isShow(allLayoutList) {
          var _this0 = this;
          return allLayoutList.find(function (i) {
            return i.key === _this0.key;
          });
        }
      }, {
        key: 'back_to_top',
        isShow: function isShow(allLayoutList) {
          var _this1 = this;
          return allLayoutList.find(function (i) {
            return i.key === _this1.key;
          });
        }
      }, {
        key: 'online_service',
        isShow: function isShow(allLayoutList) {
          var _this10 = this;
          // 仅允许添加两个
          var len = allLayoutList.filter(function (i) {
            return i.key === _this10.key;
          }).length;
          return len > 1;
        }
      }],
      //中心区域 - 满足某些条件禁止再添加的组件 对应key值
      draggedContext: ['position', 'switch_account', 'search_shop', 'aggregate_search_shop', 'five_in_one', 'system_drawer'],
      //中心区域 - 禁止自身移动排序的组件
      relatedContext: ['position', 'switch_account', 'search_shop', 'aggregate_search_shop', 'five_in_one', 'system_drawer'],
      //中心区域 - 禁止与该组件移动排序
      topDisableList: ['position', 'switch_account', 'search_shop', 'aggregate_search_shop', 'five_in_one', 'system_drawer'],
      //中心区域 - 固定在顶部 禁止移动至该组件前方
      // right start
      oldConfigData: {},
      //打开配置面板时,临时存储变量,用于验证数据是否变化
      configData: {},
      menuList: [],
      childrenMenuList: [],
      customerModuleList: [],
      eBookCategoryList: [],
      //电子书分类列表
      aBookCategoryList: [],
      //有声书分类列表
      customerPackageList: [],
      systemMenus: {},
      // right end

      // 弹窗生成模板相关 start
      show: false,
      dialogLoading: false,
      form: {
        name: '',
        //模板名称
        template_type: '',
        //模板级别
        channel_id: '',
        //渠道ID，当模板级别：1（渠道），时必填
        customer_id: '' //客户ID，当模板级别：3（客户），时必填
      },
      rules: {
        name: [{
          required: true,
          message: '模板名称不可为空',
          trigger: 'change'
        }, {
          max: 15,
          message: '模板名称不得超过15个字',
          trigger: 'change'
        }],
        template_type: [{
          required: true,
          message: '模板级别不可为空',
          trigger: 'change'
        }],
        channel_id: [{
          required: true,
          message: '请选择模板所属渠道',
          trigger: 'change'
        }],
        customer_id: [{
          required: true,
          message: '请选择模版所属客户',
          trigger: 'change'
        }]
      },
      channelList: [],
      //渠道列表
      // 弹窗生成模板相关 end

      // 弹窗切换模板 start
      templateShow: false,
      templateList: [],
      current_thumb: '',
      pages: {},
      // 弹窗切换模板 end
      showBanner: false,
      // 电影banner设置 暂时设置默认打开
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      bannerParams: {
        customer_id: this.$route.query.customer_id,
        category_id: this.$route.query.category_id,
        type: 2,
        data: [{
          thumb: '',
          link_type: '',
          link_value: ''
        }]
      },
      // log日志
      dialogShow: false,
      dialogForm: {
        operate_time: [],
        operator_id: '',
        page: 1,
        page_size: 20
      },
      logTotalCount: 0,
      logList: [],
      thumbLoading: false,
      uploadInfo: {},
      showDrawer: false,
      trendParams: {
        showTabs: ['7'],
        activeName: '7'
      },
      borderData: {}
    };
  },
  methods: {
    refreshMenus: function refreshMenus() {
      this.getMenuList();
      this.getChildrenMenu();
      this.getConfigList();
    },
    updateBorder: function updateBorder(data) {
      this.borderData = _objectSpread(_objectSpread({}, this.borderData), data);
    },
    getCustomerUrl: function getCustomerUrl(_ref) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var customer_id, customer_account_id;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              customer_id = _ref.customer_id, customer_account_id = _ref.customer_account_id;
              return _context2.a(2, new Promise(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve) {
                  var params, _yield$getUrl, is_available, _t;
                  return _regenerator().w(function (_context) {
                    while (1) switch (_context.p = _context.n) {
                      case 0:
                        _context.p = 0;
                        params = {
                          customer_id: customer_id,
                          customer_account_id: customer_account_id
                        };
                        _context.n = 1;
                        return getUrl(params);
                      case 1:
                        _yield$getUrl = _context.v;
                        is_available = _yield$getUrl.data.is_available;
                        resolve(is_available);
                        _context.n = 3;
                        break;
                      case 2:
                        _context.p = 2;
                        _t = _context.v;
                        resolve(false);
                      case 3:
                        return _context.a(2);
                    }
                  }, _callee, null, [[0, 2]]);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }()));
          }
        }, _callee2);
      }))();
    },
    previewSetting: function previewSetting() {
      var _this11 = this;
      var _this$info = this.info,
        customer_id = _this$info.customer_id,
        customer_name = _this$info.customer_name;
      getCustomerAccountOne({
        customer_id: customer_id
      }).then(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(res) {
          var is_available;
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                _this11.trendParams = _objectSpread(_objectSpread({}, _this11.trendParams), {}, {
                  customer_id: customer_id,
                  customer_name: customer_name,
                  customer_account_id: res.data.uid
                });
                // S 判断链接/二维码是否失效
                _context3.n = 1;
                return _this11.getCustomerUrl(_this11.trendParams);
              case 1:
                is_available = _context3.v;
                if (is_available) {
                  // 专属链接未实效 => 显示二维码
                  _this11.showDrawer = true;
                } else {
                  // 专属链接已实效 => 提示用户重新获取
                  _this11.handleShowLinkTips(customer_id);
                }
                // E 判断链接/二维码是否失效
              case 2:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return function (_x2) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    onCloseLinkDrawer: function onCloseLinkDrawer() {
      this.showDrawer = false;
    },
    handleShowLinkTips: function handleShowLinkTips(customer_id) {
      var _this12 = this;
      var h = this.$createElement;
      this.$msgbox({
        title: '温馨提示',
        message: h('div', {
          attrs: {
            style: 'padding: 20px 0; font-size: 13px;'
          }
        }, [h('span', null, '专属链接/二维码已失效，前往【'), h('a', {
          attrs: {
            style: 'color: #409EFF; cursor: pointer; text-decoration: none;'
          },
          on: {
            click: function click() {
              _this12.handleGoToSetLink(customer_id);
            }
          }
        }, '设置-专属链接'), h('span', null, '】配置')]),
        confirmButtonText: '关闭',
        showCancelButton: false
      }).catch(function () {});
    },
    handleGoToSetLink: function handleGoToSetLink(customer_id) {
      var _this$$router$resolve = this.$router.resolve({
          path: '/cardSystem/customer/customerManagement',
          query: {
            customer_id: customer_id,
            activeName: '7'
          }
        }),
        href = _this$$router$resolve.href;
      window.open(href, '_blank');
    },
    changePanelPage: function changePanelPage(page) {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _yield$_this13$getSup, list, totalCount;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this13.getSuperWidgetList(page);
            case 1:
              _yield$_this13$getSup = _context4.v;
              list = _yield$_this13$getSup.list;
              totalCount = _yield$_this13$getSup.totalCount;
              _this13.activeLeftData.value = list;
              _this13.panelCount = totalCount;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getSuperWidgetList: function getSuperWidgetList() {
      var _this14 = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return new Promise(function (resolve) {
        getWidgetList(_objectSpread(_objectSpread({}, _this14.panelForm), {}, {
          page: page
        })).then(function (res) {
          resolve({
            list: res.data.list || [],
            totalCount: res.pages.totalCount || 0
          });
        }).catch(function () {
          resolve({
            list: [],
            totalCount: 0
          });
        });
      });
    },
    saveThumb: function saveThumb() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$_this15$create, finalCanvas, errorMsg;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this15.thumbLoading = true;
              _this15.$store.commit('settings/SET_LOADING', true);
              _context5.n = 1;
              return _this15.createThumb('save');
            case 1:
              _yield$_this15$create = _context5.v;
              finalCanvas = _yield$_this15$create.finalCanvas;
              errorMsg = _yield$_this15$create.errorMsg;
              if (errorMsg) {
                _this15.$message.error(errorMsg);
                _this15.thumbLoading = false;
                _this15.$store.commit('settings/SET_LOADING', false);
              } else {
                finalCanvas.toBlob(function (blob) {
                  var url = URL.createObjectURL(blob);
                  var a = document.createElement('a');
                  a.href = url;
                  a.download = new Date().getTime() + '.png';
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  URL.revokeObjectURL(url);
                  _this15.thumbLoading = false;
                  _this15.$store.commit('settings/SET_LOADING', false);
                }, 'image/png');
              }
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    resetLogForm: function resetLogForm() {
      this.handleClose();
      this.getLogData();
    },
    handleClose: function handleClose() {
      this.$refs.dialogForm.resetFields();
    },
    // 获取操作日志列表
    getLogData: function getLogData(page) {
      var _this16 = this;
      this.dialogForm.page = typeof page === 'number' ? page : 1;
      var _this$info2 = this.info,
        module = _this$info2.module,
        _this$info2$channel_i = _this$info2.channel_id,
        channel_id = _this$info2$channel_i === void 0 ? '0' : _this$info2$channel_i,
        _this$info2$customer_ = _this$info2.customer_id,
        customer_id = _this$info2$customer_ === void 0 ? '0' : _this$info2$customer_;
      var _ref4 = this.dialogForm.operate_time || [],
        _ref5 = _slicedToArray(_ref4, 2),
        _ref5$ = _ref5[0],
        start_operate_time = _ref5$ === void 0 ? '' : _ref5$,
        _ref5$2 = _ref5[1],
        end_operate_time = _ref5$2 === void 0 ? '' : _ref5$2;
      start_operate_time = start_operate_time === '' ? start_operate_time : "".concat(start_operate_time, " 00:00:00");
      end_operate_time = end_operate_time === '' ? end_operate_time : "".concat(end_operate_time, " 23:59:59");
      getLog(_objectSpread({
        operate_type: this.activeTab === 'notice' ? 9 : 1,
        // 通知消息页签查看通知消息配置日志
        category_id: 0,
        // 固定传参
        channel_id: channel_id,
        customer_id: customer_id,
        start_operate_time: start_operate_time,
        end_operate_time: end_operate_time
      }, this.dialogForm), module).then(function (res) {
        var _res$data = res.data,
          data = _res$data === void 0 ? {} : _res$data,
          pages = res.pages;
        _this16.logList = data.list;
        _this16.logTotalCount = pages.totalCount;
        _this16.dialogShow = true;
      });
    },
    handleLogSizeChange: function handleLogSizeChange(size) {
      this.dialogForm.page_size = size;
      this.getLogData(1);
    },
    getTempName: function getTempName(temp_name) {
      return temp_name.length > 15 ? temp_name + '...' : temp_name;
    },
    getLayoutStyle: function getLayoutStyle(item) {
      if (item.key === 'online_service') {
        var index = this.allLayoutList.filter(function (i) {
          return i.key === item.key;
        }).findIndex(function (i) {
          return i.uid === item.uid;
        });
        return {
          top: "".concat((400 + 50 * index) / 16, "rem")
        };
      } else if (item.key === 'back_to_top') {
        return {
          top: "".concat(500 / 16, "rem") // 固定距离顶部位置 放在客服组件下方
        };
      }
      var _item$config = item.config,
        _item$config$margin_t = _item$config.margin_top,
        margin_top = _item$config$margin_t === void 0 ? 15 : _item$config$margin_t,
        _item$config$z_index = _item$config.z_index,
        z_index = _item$config$z_index === void 0 ? 2 : _item$config$z_index;
      return {
        'z-index': z_index,
        'margin-top': "".concat(margin_top / 16 / 2, "rem") // C端采用rpx像素单位,所以需要除2
      };
    },
    //删除图片
    handleDelUpload: function handleDelUpload(index) {
      var _this17 = this;
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this17.bannerParams.data.splice(index, 1);
      });
    },
    handleBanner: function handleBanner() {
      var _this18 = this;
      var params = _objectSpread({}, this.bannerParams);
      params.data = JSON.stringify(params.data);
      var module = this.info.module;
      movieBanner(_objectSpread({}, params), 'post', module).then(function (res) {
        _this18.$message.success('操作成功');
        _this18.showBanner = false;
      });
    },
    addUpload: function addUpload() {
      this.bannerParams.data.push({
        thumb: '',
        link_type: '',
        link_value: ''
      });
    },
    emitUploadFile: function emitUploadFile(res, item) {
      item.thumb = "".concat(this.$ossurl).concat(res);
    },
    removeLayout: function removeLayout(item, index, removeType) {
      var _this19 = this;
      this.$confirm("\u786E\u8BA4\u8981\u5220\u9664\u3010".concat(item.widget, "\u3011\u5417"), '提示', {
        confirmButtonText: '确定',
        type: 'warning'
      }).then(function () {
        item.uid === _this19.configData.uid && _this19.closeConfigPanel();
        if (removeType === 'bottom') {
          _this19.bottomData = {};
        } else {
          _this19.layoutList.splice(index, 1);
        }
      }).catch(function () {});
    },
    // 选择模板
    selectTemp: function selectTemp(data) {
      var _this20 = this;
      this.$router.replace({
        path: this.$route.path,
        query: _objectSpread(_objectSpread({}, this.$route.query), {}, {
          temp_id: data.id,
          temp_name: data.name,
          t: new Date().getTime()
        })
      }, function () {
        _this20.templateShow = false;
        _this20.init({
          changeTab: false
        });
      });
    },
    // 获取模板列表
    getTemplate: function getTemplate() {
      var _this21 = this;
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _params$page = params.page,
        page = _params$page === void 0 ? 1 : _params$page,
        type = params.type,
        cb = params.cb,
        scroll_cb = params.scroll_cb;
      var _this$info3 = this.info,
        channel_id = _this$info3.channel_id,
        customer_id = _this$info3.customer_id,
        module = _this$info3.module,
        _this$info3$category_ = _this$info3.category_id,
        category_id = _this$info3$category_ === void 0 ? '' : _this$info3$category_;
      getTemplateList(_objectSpread(_objectSpread({
        style_id: this.style_id,
        // category_id,
        category_id: 'all'
      }, customer_id ? {
        customer_id: customer_id
      } : {
        channel_id: channel_id
      }), {}, {
        page: page
      }), module).then(function (res) {
        var _res$pages = res.pages,
          pages = _res$pages === void 0 ? {} : _res$pages;
        var _res$data2 = res.data,
          _res$data2$list = _res$data2.list,
          list = _res$data2$list === void 0 ? [] : _res$data2$list,
          _res$data2$current_th = _res$data2.current_thumb,
          current_thumb = _res$data2$current_th === void 0 ? '' : _res$data2$current_th;
        _this21.pages = pages;
        _this21.current_thumb = current_thumb;
        _this21.templateList = page > 1 ? _this21.templateList.concat(list) : list;
        if (type === 'loadMore') {
          cb && cb();
          return;
        }
        _this21.templateShow = true;
        if (scroll_cb) {
          _this21.$nextTick(function () {
            if (_this21.$refs.tempContent) {
              _this21.$refs.tempContent.scrollTop = _this21.$refs.tempContent.clientHeight / 2;
            }
          });
        }
      });
    },
    // 截图 生成缩略图
    createThumb: function createThumb(type) {
      var _this22 = this;
      return new Promise(function (resolve) {
        var _this22$$refs$bottomR;
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        _this22.$refs.phone.scrollTop = 0;
        var canvasID = document.getElementById('draggableCenter');
        var bottomElement = (_this22$$refs$bottomR = _this22.$refs.bottomRef) === null || _this22$$refs$bottomR === void 0 ? void 0 : _this22$$refs$bottomR.$el;
        var width = canvasID.clientWidth;
        var height = canvasID.clientHeight;
        var height2 = bottomElement === null || bottomElement === void 0 ? void 0 : bottomElement.clientHeight;
        var params = _objectSpread(_objectSpread({
          useCORS: true
        }, type === 'save' ? {
          scale: 3
        } : {
          scale: window.devicePixelRatio < 3 ? window.devicePixelRatio : 2
        }), {}, {
          scrollY: 0,
          scrollX: 0,
          width: width,
          height: height
        });
        var draw = function draw(canvas1, canvas2) {
          // 创建新的canvas元素拼接两个截图
          var finalCanvas = document.createElement('canvas');
          if (canvas2) {
            finalCanvas.width = Math.max(canvas1.width, canvas2.width);
            finalCanvas.height = canvas1.height + canvas2.height;
            var ctx = finalCanvas.getContext('2d');
            ctx.drawImage(canvas1, 0, 0);
            ctx.drawImage(canvas2, 0, canvas1.height);
          } else {
            finalCanvas.width = canvas1.width;
            finalCanvas.height = canvas1.height;
            var _ctx = finalCanvas.getContext('2d');
            _ctx.drawImage(canvas1, 0, 0);
          }
          if (type === 'save') {
            resolve({
              finalCanvas: finalCanvas
            });
            return;
          }

          // 将拼接后的截图添加到页面中
          var dom = document.body.appendChild(finalCanvas);
          dom.style.display = 'none';
          var blob = dataURLToBlob(dom.toDataURL('image/jpeg'));
          var fileOfBlob = new File([blob], new Date().getTime() + '.jpeg');
          uploadFile(fileOfBlob).then(function (response) {
            if (response.status === 200) {
              resolve({
                thumb: "".concat(_this22.$ossurl).concat(response.config.key)
              });
            } else {
              resolve({
                errorMsg: '生成缩略图失败,请重新尝试'
              });
            }
          }).catch(function () {
            resolve({
              errorMsg: '生成缩略图失败,请重新尝试'
            });
          }).finally(function () {
            document.body.removeChild(dom);
          });
        };
        _this22.$nextTick(function () {
          html2Canvas(canvasID, params).then(function (canvas1) {
            if (bottomElement) {
              html2Canvas(bottomElement, _objectSpread(_objectSpread({}, params), {}, {
                height: height2
              })).then(function (canvas2) {
                draw(canvas1, canvas2);
              });
            } else {
              draw(canvas1);
            }
          }).catch(function (errorMsg) {
            resolve({
              errorMsg: errorMsg
            });
          }).finally(function () {
            canvasID.style.backgroundSize = '';
          });
        });
      });
    },
    // 确认生成模板
    onSubmit: function onSubmit() {
      var _this23 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _this23.$refs.dialogForm.validate(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(valid) {
                  var _yield$_this23$create, _yield$_this23$create2, thumb, _yield$_this23$create3, errorMsg, _this23$info, channel_id, customer_id, category_id, module, params, res, ids;
                  return _regenerator().w(function (_context6) {
                    while (1) switch (_context6.n) {
                      case 0:
                        if (!valid) {
                          _context6.n = 5;
                          break;
                        }
                        _this23.closeConfigPanel();
                        _this23.dialogLoading = true;
                        _context6.n = 1;
                        return _this23.createThumb();
                      case 1:
                        _yield$_this23$create = _context6.v;
                        _yield$_this23$create2 = _yield$_this23$create.thumb;
                        thumb = _yield$_this23$create2 === void 0 ? '' : _yield$_this23$create2;
                        _yield$_this23$create3 = _yield$_this23$create.errorMsg;
                        errorMsg = _yield$_this23$create3 === void 0 ? '' : _yield$_this23$create3;
                        if (!errorMsg) {
                          _context6.n = 2;
                          break;
                        }
                        _this23.$message.error(errorMsg);
                        _this23.dialogLoading = false;
                        _this23.releaseLoading = false;
                        return _context6.a(2);
                      case 2:
                        _this23$info = _this23.info, channel_id = _this23$info.channel_id, customer_id = _this23$info.customer_id, category_id = _this23$info.category_id, module = _this23$info.module;
                        params = _objectSpread(_objectSpread({}, _this23.form), {}, {
                          thumb: thumb,
                          category_id: category_id
                        });
                        params.channel_id = params.channel_id || channel_id;
                        params.customer_id = params.customer_id || customer_id;
                        params.style_id = _this23.style_id;
                        if (!(_this23.form.template_type === '1' && !_this23.form.channel_id)) {
                          _context6.n = 4;
                          break;
                        }
                        _context6.n = 3;
                        return _this23.loadChannel();
                      case 3:
                        res = _context6.v;
                        params.channel_id = res.data.channel_id;
                      case 4:
                        _this23.form.template_type !== '1' && delete params.channel_id;
                        _this23.form.template_type !== '3' && delete params.customer_id;
                        ids = _this23.allLayoutList.map(function (i) {
                          return i.unique_id;
                        });
                        generateTemplate(_objectSpread(_objectSpread({}, params), {}, {
                          data: JSON.stringify(ids)
                        }, _this23.background_config), module).then(function (res) {
                          _this23.$message.success('操作成功');
                          _this23.show = false;
                        }).finally(function (_) {
                          _this23.dialogLoading = false;
                        });
                      case 5:
                        return _context6.a(2);
                    }
                  }, _callee6);
                }));
                return function (_x3) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 1:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    // 生成模板
    createTemplate: function createTemplate() {
      var _this24 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var verify, data;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              verify = _this24.verifyList('生成模板');
              if (verify) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              if (!(_this24.info.module === 'admin')) {
                _context8.n = 3;
                break;
              }
              _context8.n = 2;
              return _this24.loadChannelList();
            case 2:
              data = _context8.v;
              _this24.channelList = data || [];
            case 3:
              _this24.show = true;
              _this24.$nextTick(function () {
                var _this24$$refs$dialogF;
                (_this24$$refs$dialogF = _this24.$refs.dialogForm) === null || _this24$$refs$dialogF === void 0 ? void 0 : _this24$$refs$dialogF.resetFields();
              });
            case 4:
              return _context8.a(2);
          }
        }, _callee8);
      }))();
    },
    // 获取渠道列表
    loadChannelList: function loadChannelList() {
      return new Promise(function (resolve) {
        getChannelList().then(function (res) {
          resolve(res.data);
        });
      });
    },
    // 保存基本设置
    saveBasic: function saveBasic() {
      var _this25 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              _this25.activeTab = _this25.oldActiveTab || _this25.activeTab;
              // this.template_config_id = ''
              _this25.init({
                template_config_id: ''
              });
              // const { background_config = {} } = await this.getHomeData() // 保存基础设置后 更新背景图信息
              // this.background_config = background_config
            case 1:
              return _context9.a(2);
          }
        }, _callee9);
      }))();
    },
    // 中心区域 判定禁止移动排序组件
    onMoveCenter: function onMoveCenter(e) {
      var draggedContext = e.draggedContext,
        relatedContext = e.relatedContext;
      return !this.draggedContext.includes(draggedContext.element.key) && !this.relatedContext.includes(relatedContext.element.key);
    },
    showOneIcon: function showOneIcon(index, data) {
      var _this26 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return _this26.switchPanel(data);
            case 1:
              // 校验切换面板前组件中的新旧数据是否一致 是否要弹窗
              _this26.configData = data;
              _this26.oldConfigData = JSON.parse(JSON.stringify(data));
              _this26.$nextTick(function () {
                typeof _this26.$refs.config.setCategory === 'function' && _this26.$refs.config.setCategory(index);
              });
            case 2:
              return _context0.a(2);
          }
        }, _callee0);
      }))();
    },
    // 左侧面板移动事件 禁止移动至底部导航后方与定位组件前方
    onMovePanel: function onMovePanel(e) {
      var _relatedContext$eleme;
      var draggedContext = e.draggedContext,
        relatedContext = e.relatedContext;

      // const length = relatedContext.list.length
      // if (length > 0 && draggedContext.futureIndex === length) {
      // 	// 因为有底部导航 禁止移动至底部
      // 	const bottom = relatedContext.list.find(i => i.key === 'bottom')
      // 	return bottom === undefined
      // }

      if (this.topDisableList.includes((_relatedContext$eleme = relatedContext.element) === null || _relatedContext$eleme === void 0 ? void 0 : _relatedContext$eleme.key) && draggedContext.futureIndex <= this.topLastIndex) {
        // 禁止移动至定位组件 切换企业组件上方
        return false;
      }
      return true;
    },
    // 左侧面板移动完成事件
    moveEndPanel: function moveEndPanel(e) {
      var _this27 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        var newDraggableIndex, to, item, classList, curWidget;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              newDraggableIndex = e.newDraggableIndex, to = e.to, item = e.item; // 因为在左侧面板内也可移动位置,所以移动结束后需要判断是否移动至手机中心屏幕
              // 如移动至手机中心屏幕,需要给当前数据增加uid属性 用于绑定循环的组件唯一key值
              if (!(to.id === 'draggableCenter')) {
                _context1.n = 2;
                break;
              }
              // position定位组件只允许添加至顶部
              classList = _toConsumableArray(item.classList); // if (classList.includes('position') && newDraggableIndex !== 0) {
              // 	this.$message.error(
              // 		`${this.layoutList[newDraggableIndex].widget}只允许添加至顶部`
              // 	)
              // 	this.layoutList.splice(newDraggableIndex, 1)
              // } else {
              // await this.switchPanel() // 校验切换面板前组件中的新旧数据是否一致 是否要弹窗
              curWidget = _this27.layoutList[newDraggableIndex];
              if (!(curWidget.group === 'super_widget')) {
                _context1.n = 1;
                break;
              }
              _this27.layoutList.splice(newDraggableIndex, 1);
              _this27.addPanel(curWidget, newDraggableIndex);
              return _context1.a(2);
            case 1:
              _this27.$set(_this27.layoutList, newDraggableIndex, _objectSpread(_objectSpread({}, _this27.layoutList[newDraggableIndex]), {}, {
                uid: guid()
              }));
              _this27.configData = _this27.layoutList[newDraggableIndex]; // 自动打开右侧配置项
              _this27.oldConfigData = JSON.parse(JSON.stringify(_this27.layoutList[newDraggableIndex]));
              // }
              _this27.$nextTick(function () {
                // 暂时性没有配置数据的组件 手动调用一下保存事件 缓存单组件unique_id
                if (_this27.noConfigList.includes(_this27.configData.key)) {
                  _this27.saveConfig();
                }
              });
            case 2:
              return _context1.a(2);
          }
        }, _callee1);
      }))();
    },
    // 关闭配置面板
    closeConfigPanel: function closeConfigPanel() {
      var _arguments = arguments,
        _this28 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var params, value, msg_success;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              params = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
              value = params.value, msg_success = params.msg_success;
              if (!value) {
                _context10.n = 1;
                break;
              }
              _context10.n = 1;
              return _this28.saveConfig(value);
            case 1:
              _this28.configData = {};
              _this28.oldConfigData = {};
              msg_success && _this28.$message.success(msg_success);
            case 2:
              return _context10.a(2);
          }
        }, _callee10);
      }))();
    },
    // 校验所有表单项是否填写完整
    verifyList: function verifyList(type) {
      var _this29 = this;
      if (this.allLayoutList.length < 1) {
        this.$message.error("\u81F3\u5C11\u914D\u7F6E\u4E00\u4E2A\u7EC4\u4EF6\u624D\u53EF\u8FDB\u884C".concat(type, "\u64CD\u4F5C"));
        return;
      }
      var data = [];
      this.layoutList.forEach(function (i) {
        _this29.$set(i, 'error', i.validFail || !i.unique_id);
        if (i.error) {
          data.push(i.widget);
        }
      });
      if (!isEmpty(this.bottomData)) {
        var _this$bottomData = this.bottomData,
          validFail = _this$bottomData.validFail,
          unique_id = _this$bottomData.unique_id,
          widget = _this$bottomData.widget;
        this.$set(this.bottomData, 'error', validFail || !unique_id);
        if (this.bottomData.error) {
          data.push(widget);
        }
      }
      // const data = this.allLayoutList.find(i => {
      // 	return i.validFail || !i.unique_id
      // })
      if (data.length) {
        this.$message.error("".concat(_toConsumableArray(new Set(data)).toString(), "\u697C\u5C42\u672A\u914D\u7F6E\u5B8C\u5584\uFF0C\u914D\u7F6E\u5E76\u4FDD\u5B58\u540E\u518D\u6765").concat(type, "\u5427"));
        this.$nextTick(function () {
          scrollToError('#phone #draggableCenter .error');
        });
        return;
      }
      return true;
    },
    getPopupResult: function getPopupResult() {
      var _this30 = this;
      return new Promise(function (resolve, reject) {
        if (_this30.home_style === 'user_defined') {
          resolve({});
          return;
        }
        var msg = _this30.info.category_id ? '当前菜单为默认风格，是否改为自定义风格' : '当前首页风格不是自定义，是否发布并改为自定义';
        var confirmButtonText = _this30.info.category_id ? '发布并改为自定义' : '确认';
        _this30.$confirm(msg, '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: confirmButtonText,
          cancelButtonText: '仅发布'
        }).then(function () {
          resolve({
            is_user_defined: 1
          });
        }).catch(function (action) {
          action === 'cancel' ? resolve({}) : reject();
        });
      });
    },
    /**
     * 发布
     */
    release: function release() {
      var _this31 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var verify, params, ids, _yield$_this31$create, _yield$_this31$create2, thumb, _yield$_this31$create3, errorMsg, _this31$info, category_id, module, group_type, req, _t2;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              verify = _this31.verifyList('发布');
              if (verify) {
                _context12.n = 1;
                break;
              }
              return _context12.a(2);
            case 1:
              _context12.p = 1;
              // const params = await this.getPopupResult() //gyp让注释的 后端有问题
              params = {};
              _this31.releaseLoading = true;
              ids = _this31.allLayoutList.map(function (i) {
                return i.unique_id;
              });
              _context12.n = 2;
              return _this31.createThumb();
            case 2:
              _yield$_this31$create = _context12.v;
              _yield$_this31$create2 = _yield$_this31$create.thumb;
              thumb = _yield$_this31$create2 === void 0 ? '' : _yield$_this31$create2;
              _yield$_this31$create3 = _yield$_this31$create.errorMsg;
              errorMsg = _yield$_this31$create3 === void 0 ? '' : _yield$_this31$create3;
              if (!errorMsg) {
                _context12.n = 3;
                break;
              }
              _this31.$message.error(errorMsg);
              _this31.dialogLoading = false;
              _this31.releaseLoading = false;
              return _context12.a(2);
            case 3:
              _this31$info = _this31.info, category_id = _this31$info.category_id, module = _this31$info.module, group_type = _this31$info.group_type;
              req = save;
              if (category_id) {
                req = saveCategory;
              }
              req(_objectSpread(_objectSpread(_objectSpread({
                data: JSON.stringify(ids),
                style_id: _this31.style_id,
                thumb: thumb
              }, params), ['custom', 'plat_custom', 'service_custom', 'plat_service_custom'].includes(module) ? {
                is_channel: _this31.is_channel
              } : {}), group_type == '2' ? {
                is_user_defined: 1 // 功能菜单装修 - 若为组合功能模块 需传递该参数
              } : {}), module).then(/*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(_) {
                  var temp_id, msg, _yield$_this31$getHom, home_style;
                  return _regenerator().w(function (_context11) {
                    while (1) switch (_context11.n) {
                      case 0:
                        temp_id = _this31.info.temp_id;
                        msg = '发布成功';
                        if (temp_id && !['cur', 'new'].includes(temp_id)) {
                          msg = '发布成功，若模板背景色与之前不同，需在基础设置页保存哦';
                        }
                        _this31.$message.success(msg);
                        _this31.info.temp_id = 'cur';
                        _this31.info.temp_name = '';
                        _this31.$router.replace({
                          path: _this31.$route.path,
                          query: _objectSpread(_objectSpread({}, _this31.$route.query), {}, {
                            temp_id: 'cur',
                            temp_name: ''
                          })
                        });
                        // 更新获取当前装修风格是否为装修
                        _context11.n = 1;
                        return _this31.getHomeData();
                      case 1:
                        _yield$_this31$getHom = _context11.v;
                        home_style = _yield$_this31$getHom.home_style;
                        _this31.home_style = home_style;
                      case 2:
                        return _context11.a(2);
                    }
                  }, _callee11);
                }));
                return function (_x4) {
                  return _ref7.apply(this, arguments);
                };
              }()).finally(function () {
                _this31.releaseLoading = false;
              });
              _context12.n = 5;
              break;
            case 4:
              _context12.p = 4;
              _t2 = _context12.v;
            case 5:
              return _context12.a(2);
          }
        }, _callee12, null, [[1, 4]]);
      }))();
    },
    /**
     * 右侧保存单个组件 配置信息
     */
    saveConfig: function saveConfig(data) {
      var _this32 = this;
      return new Promise(function (resolve) {
        if (_this32.disabled) {
          resolve();
          return;
        }
        var module = _this32.info.module;
        if (data) {
          /**
           * 兼容类似增加默认底部导航时 需要先进行一次保存操作
           * 因有默认值,无需校验表单 & 因未展开右侧配置面板,无法校验表单问题
           */
          update({
            key: data.key,
            style_id: _this32.style_id,
            params: JSON.stringify(data.config)
          }, module).then(/*#__PURE__*/function () {
            var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(res) {
              return _regenerator().w(function (_context13) {
                while (1) switch (_context13.n) {
                  case 0:
                    data.unique_id = res.data.unique_id;
                    _context13.n = 1;
                    return _this32.updateCB(_this32.style_id, res.data, data);
                  case 1:
                    // 更新父组件数据
                    resolve();
                  case 2:
                    return _context13.a(2);
                }
              }, _callee13);
            }));
            return function (_x5) {
              return _ref8.apply(this, arguments);
            };
          }()).catch(function (_) {
            resolve();
          });
          return;
        }
        var _this32$configData = _this32.configData,
          key = _this32$configData.key,
          widget = _this32$configData.widget,
          _this32$configData$co = _this32$configData.config,
          config = _this32$configData$co === void 0 ? {} : _this32$configData$co;
        if (key === 'super_nav') {
          _this32.configData.dialogFormValid = !config.value.some(function (i) {
            return i.valid === false;
          });
        }
        if (key === 'five_in_one') {
          var _ref9 = config.menus || {},
            flag = _ref9.flag,
            valid = _ref9.valid;
          if (config.show_style === 1 || !flag) {
            _this32.configData.dialogFormValid = true;
          } else {
            // 更多功能框开启时需功能抽屉校验通过 valid为前端临时标记 后端回显可能丢失 仅在明确为false时拦截
            _this32.configData.dialogFormValid = valid !== false;
          }
        }
        _this32.$refs.config.$refs.form.validate(function (valid, obj) {
          if (valid) {
            if (['icon', 'super_nav', 'five_in_one'].includes(key) && _this32.configData.dialogFormValid !== true) {
              _this32.configData.validFail = true; //表单校验失败
              _this32.$set(_this32.configData, 'error', true); // 表单校验失败 将红框标识设为true
              var msg_instance = _this32.$message.error("".concat(widget, "\u5206\u7C7B\u8868\u5355\u6821\u9A8C\u5931\u8D25\uFF0C\u8BF7\u5148\u6309\u89C4\u5219\u8BBE\u7F6E\u5206\u7C7B\u6570\u636E"));
              resolve(msg_instance);
              return;
            }
            _this32.configData.validFail = false; //表单校验是否失败
            _this32.$set(_this32.configData, 'error', false); // 表单校验通过 将红框标识设为false
            _this32.configLoading = true;
            update({
              key: key,
              style_id: _this32.style_id,
              params: JSON.stringify(config)
            }, module).then(function (res) {
              _this32.$message.success('操作成功');
              _this32.configData.unique_id = res.data.unique_id;
              _this32.updateCB(_this32.style_id, res.data, _this32.configData);
            }).finally(function () {
              _this32.configLoading = false;
              resolve();
            });
          } else {
            var _Object$values, _Object$values$, _Object$values$$;
            _this32.configData.validFail = true; //表单校验是否失败
            _this32.$set(_this32.configData, 'error', true); // 表单校验失败 将红框标识设为true
            var errorMsg = (_Object$values = Object.values(obj)) === null || _Object$values === void 0 ? void 0 : (_Object$values$ = _Object$values[0]) === null || _Object$values$ === void 0 ? void 0 : (_Object$values$$ = _Object$values$[0]) === null || _Object$values$$ === void 0 ? void 0 : _Object$values$$.message;
            var _msg_instance = _this32.$message.error("".concat(widget).concat(errorMsg));
            resolve(_msg_instance);
          }
        });
      });
    },
    // 校验切换面板前组件中的新旧数据是否一致 是否要弹窗
    switchPanel: function switchPanel(newPanel) {
      var _this33 = this;
      return new Promise(function (resolve) {
        var _this33$$refs$config, _this33$$refs$config$, _this33$$refs$config2, _this33$$refs$config3, _this33$$refs$config4;
        if (((_this33$$refs$config = _this33.$refs.config) === null || _this33$$refs$config === void 0 ? void 0 : (_this33$$refs$config$ = _this33$$refs$config.$refs) === null || _this33$$refs$config$ === void 0 ? void 0 : _this33$$refs$config$.form) === undefined || newPanel.uid === _this33.configData.uid) {
          resolve();
          return;
        }
        (_this33$$refs$config2 = _this33.$refs.config) === null || _this33$$refs$config2 === void 0 ? void 0 : (_this33$$refs$config3 = _this33$$refs$config2.$refs) === null || _this33$$refs$config3 === void 0 ? void 0 : (_this33$$refs$config4 = _this33$$refs$config3.form) === null || _this33$$refs$config4 === void 0 ? void 0 : _this33$$refs$config4.validate(function (valid) {
          _this33.configData.validFail = !valid; //表单校验是否失败
        });
        var _this33$configData = _this33.configData,
          cur = _this33$configData.config,
          cur_unique_id = _this33$configData.unique_id,
          validFail = _this33$configData.validFail;
        var _this33$oldConfigData = _this33.oldConfigData,
          old = _this33$oldConfigData.config,
          old_unique_id = _this33$oldConfigData.unique_id;
        var cur_config_str = JSON.stringify(cur);
        var old_config_str = JSON.stringify(old);
        var cur_keys_len = Object.keys(cur).length;
        var old_keys_len = Object.keys(old).length;

        // 如果当前数据表单校验没过 或者数据变了,但没有进行保存操作(也就是换新的unique_id)
        // 表示需要弹窗询问切换提示
        var validArr = [validFail,
        // 数据表单校验没过
        cur_keys_len === old_keys_len && cur_unique_id === old_unique_id && cur_config_str !== old_config_str //都是新数据,数据变了,没有进行保存
        ];
        if (validArr.some(function (i) {
          return i;
        })) {
          _this33.$confirm("".concat(_this33.configData.widget, "\u7EC4\u4EF6\u6709\u4FEE\u6539\u7684\u914D\u7F6E\u672A\u4FDD\u5B58\uFF0C\u662F\u5426\u4FDD\u5B58"), '切换组件提示', {
            confirmButtonText: '保存',
            cancelButtonText: '不保存',
            type: 'warning'
          }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
            var msg_instance;
            return _regenerator().w(function (_context14) {
              while (1) switch (_context14.n) {
                case 0:
                  _context14.n = 1;
                  return _this33.saveConfig();
                case 1:
                  msg_instance = _context14.v;
                  msg_instance && _this33.$message.error("".concat(_this33.configData.widget, "\u7EC4\u4EF6\u6709\u5F85\u5B8C\u5584\u4FE1\u606F\uFF0C\u7A0D\u540E\u5B8C\u5584\u540E\u518D\u4FDD\u5B58\u54E6"));
                  msg_instance === null || msg_instance === void 0 ? void 0 : msg_instance.close();
                  resolve();
                case 2:
                  return _context14.a(2);
              }
            }, _callee14);
          }))).catch(function () {
            resolve();
          });
        } else {
          resolve();
        }
      });
    },
    // 点击主屏幕内组件,弹出右侧配置项
    plateHandle: function plateHandle(item) {
      var _this34 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              _context15.n = 1;
              return _this34.switchPanel(item);
            case 1:
              // 校验切换面板前组件中的新旧数据是否一致 是否要弹窗
              _this34.configData = item;
              _this34.oldConfigData = JSON.parse(JSON.stringify(item));
            case 2:
              return _context15.a(2);
          }
        }, _callee15);
      }))();
    },
    // 添加定位 & 搜索 & 切换企业 组合套件
    addBox: function addBox(item, insertIndex) {
      var _this35 = this;
      if (item.group === 'super_widget') {
        getWidgetValue({
          unique_id: item.key
        }).then(/*#__PURE__*/function () {
          var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(res) {
            var _res$data3, data, _iterator, _step, _item, _t3;
            return _regenerator().w(function (_context16) {
              while (1) switch (_context16.p = _context16.n) {
                case 0:
                  _res$data3 = res.data, data = _res$data3 === void 0 ? [] : _res$data3; // 如果传了指定插入的index 则表示是拖拽添加的 需要将数据倒序插入 这样插入后顺序才是正确的
                  // 不然需要累加index 确保插入顺序正确，但部分组件不满足添加条件 会导致累计index不准确
                  if (typeof insertIndex === 'number') {
                    data = data.reverse();
                  }
                  _iterator = _createForOfIteratorHelper(data);
                  _context16.p = 1;
                  _iterator.s();
                case 2:
                  if ((_step = _iterator.n()).done) {
                    _context16.n = 5;
                    break;
                  }
                  _item = _step.value;
                  _context16.n = 3;
                  return _this35.saveConfig(_item);
                case 3:
                  _this35.addPanel(_item, insertIndex);
                case 4:
                  _context16.n = 2;
                  break;
                case 5:
                  _context16.n = 7;
                  break;
                case 6:
                  _context16.p = 6;
                  _t3 = _context16.v;
                  _iterator.e(_t3);
                case 7:
                  _context16.p = 7;
                  _iterator.f();
                  return _context16.f(7);
                case 8:
                  return _context16.a(2);
              }
            }, _callee16, null, [[1, 6, 7, 8]]);
          }));
          return function (_x6) {
            return _ref1.apply(this, arguments);
          };
        }());
      } else {
        item.default_value.forEach(function (key) {
          var data = _this35.tabListFlat.find(function (i) {
            return i.key === key;
          });
          data && _this35.addPanel(data);
        });
      }
    },
    //点击左侧组件面板 往手机中可拖拽元素数据内push数据
    addPanel: function addPanel(item, insertIndex) {
      var _this36 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        var maxData, message, _data, data, positionIndex;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              maxData = _this36.leftFilterDomList.find(function (key) {
                return key === item.key;
              });
              if (!(maxData !== undefined)) {
                _context17.n = 1;
                break;
              }
              message = "".concat(item.widget, "\u5DF2\u8FBE\u5230\u6700\u5927\u6DFB\u52A0\u6570");
              if (_this36.topDisableList.includes(item.key)) {
                _data = _this36.filterList.find(function (i) {
                  return i.key === item.key;
                });
                if (_this36.allLayoutList.find(function (i) {
                  var _data$mutual_keys;
                  return (_data$mutual_keys = _data.mutual_keys) === null || _data$mutual_keys === void 0 ? void 0 : _data$mutual_keys.includes(i.key);
                })) {
                  message = "".concat(item.widget, "\u4E0E").concat(_data.isShow(_this36.allLayoutList).widget, "\u4E92\u65A5\uFF0C\u8BF7\u91CD\u65B0\u9009\u62E9\u7EC4\u4EF6");
                }
              }
              _this36.$message({
                type: 'error',
                message: message,
                showClose: true
              });
              return _context17.a(2, false);
            case 1:
              if (!(item.group === 'super_widget' || item.key === 'box_position_search_switch')) {
                _context17.n = 2;
                break;
              }
              _this36.addBox(item, insertIndex);
              return _context17.a(2, false);
            case 2:
              if (!['bottom'].includes(item.key)) {
                _context17.n = 3;
                break;
              }
              _this36.addBottom(item.key);
              return _context17.a(2);
            case 3:
              data = _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(item))), {}, {
                uid: guid()
              }); // await this.switchPanel() // 校验切换面板前组件中的新旧数据是否一致 是否要弹窗
              if (['position', 'five_in_one'].includes(item.key)) {
                // 定位组件只允许添加至最顶层
                _this36.layoutList.unshift(data);
              } else if (['switch_account', 'search_shop', 'aggregate_search_shop', 'system_drawer'].includes(item.key)) {
                // 切换企业组件 添加至顶部或定位组件右方
                // 搜索框组件 添加至顶部或定位组件右方
                positionIndex = _this36.layoutList.findIndex(function (i) {
                  return i.key === 'position';
                });
                _this36.layoutList.splice(positionIndex + 1, 0, data);
              } else {
                if (typeof insertIndex === 'number') {
                  _this36.layoutList.splice(insertIndex, 0, data);
                } else {
                  // 其他组件添加至最底部
                  _this36.layoutList.push(data);
                }
              }
              _this36.configData = data; // 自动打开右侧配置项
              _this36.oldConfigData = JSON.parse(JSON.stringify(data));
              // 暂时性没有配置数据的组件 手动调用一下保存事件 缓存单组件unique_id
              _this36.$nextTick(function () {
                var _this36$$refs$phone;
                if (_this36.noConfigList.includes(data.key)) {
                  _this36.saveConfig(data);
                }
                if (typeof insertIndex === 'number') {
                  return;
                }
                _this36.$refs.phone.scrollTop = [].concat(_toConsumableArray(_this36.topDisableList), ['online_service', 'back_to_top']).includes(item.key) ? 0 : (_this36$$refs$phone = _this36.$refs.phone) === null || _this36$$refs$phone === void 0 ? void 0 : _this36$$refs$phone.scrollHeight;
              });
            case 4:
              return _context17.a(2);
          }
        }, _callee17);
      }))();
    },
    // 获取左侧组件面板数据
    getLeftPanel: function getLeftPanel(params) {
      var _this37 = this;
      var changeTab = params.changeTab;
      var _this$info4 = this.info,
        category_id = _this$info4.category_id,
        module = _this$info4.module;
      return new Promise(function (resolve) {
        getComponents(_objectSpread({
          style_id: _this37.style_id
        }, category_id ? {
          category_id: category_id
        } : {}), module).then(/*#__PURE__*/function () {
          var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(res) {
            var _res$data$find, _res$data$find$value, value, searchIndex, _yield$_this37$getSup, list, totalCount, superWidgetTab;
            return _regenerator().w(function (_context18) {
              while (1) switch (_context18.n) {
                case 0:
                  if (!res.data.length) {
                    _context18.n = 2;
                    break;
                  }
                  _res$data$find = res.data.find(function (i) {
                    return i.group_key === 'general';
                  }), _res$data$find$value = _res$data$find.value, value = _res$data$find$value === void 0 ? [] : _res$data$find$value; // 查找到通用 - 普通搜索栏组件（可以往页面任何地方拖拽）
                  searchIndex = value.findIndex(function (i) {
                    return i.key === 'basic_search_shop';
                  });
                  if (searchIndex > -1) {
                    value.splice(searchIndex, 1, _objectSpread(_objectSpread({}, value[searchIndex]), {}, {
                      key_pointer: 'aggregate_search_shop' // key指向aggregate_search_shop 预览区&配置区均采用该模块
                    }));
                  }
                  // 通用-组合魔方导航组件-将每个样式逐一放出来，方便用户快速选择样式
                  _this37.splitGroup(res.data, 'general', 'magic_nav', function (magic_nav, item) {
                    return {
                      widget_alias: "".concat(magic_nav.widget).concat(item.magic_type),
                      // 左侧组件列表要显示的可自定义的组件名
                      magic_type: item.magic_type,
                      icon: item.imageurl
                    };
                  });
                  // 礼包-产品分类组件-将每个样式逐一放出来，方便用户快速选择样式
                  _this37.splitGroup(res.data, 'package', 'package_list', function (_, item) {
                    return {
                      widget: item.title,
                      widget_alias: ''
                    };
                  });
                  // 通用-五合一组件
                  _this37.splitGroup(res.data, 'general', 'five_in_one', function (_, item) {
                    return {
                      widget: '五合一组件',
                      widget_alias: item.title
                    };
                  });
                  // 商城-产品分类组件-将每个样式逐一放出来，方便用户快速选择样式
                  _this37.splitGroup(res.data, 'mall', 'goods_nav');
                  // 生日-产品分类组件-将每个样式逐一放出来，方便用户快速选择样式
                  _this37.splitGroup(res.data, 'birthday', 'birthday_nav');
                  // 演出-产品分类组件-将每个样式逐一放出来，方便用户快速选择样式
                  _this37.splitGroup(res.data, 'yanchu', 'yanchu_goods_nav');
                  // 演出-产品列表组件-将每个样式逐一放出来，方便用户快速选择样式
                  _this37.splitGroup(res.data, 'yanchu', 'yanchu_goods_list');
                  // 智慧工会-职工书屋楼层组件-将每个样式逐一放出来，方便用户快速选择样式
                  _this37.splitGroup(res.data, 'saas', 'saas_staff_library');
                  _context18.n = 1;
                  return _this37.getSuperWidgetList();
                case 1:
                  _yield$_this37$getSup = _context18.v;
                  list = _yield$_this37$getSup.list;
                  totalCount = _yield$_this37$getSup.totalCount;
                  // 获取组合套件数据
                  superWidgetTab = res.data.find(function (i) {
                    return i.group_key === 'super_widget';
                  });
                  if (superWidgetTab) {
                    superWidgetTab.value = list;
                    _this37.panelCount = totalCount;
                  }

                  // 主数据中拿出本次已有数据key值
                  // 循环左侧面板组件数据,设置config属性初始配置数据
                  res.data.forEach(function (tab) {
                    tab.value.forEach(function (val) {
                      _this37.$set(val, 'config', {});
                    });
                  });
                  _this37.tabList = res.data;
                  _context18.n = 3;
                  break;
                case 2:
                  _this37.noPlate = true;
                case 3:
                  _this37.tabList.push({
                    name: '基础设置',
                    group_key: 'basic',
                    value: []
                  });
                  if (_this37.canShowNoticeTab) {
                    _this37.tabList.push({
                      name: '通知消息',
                      group_key: 'notice',
                      value: []
                    });
                  }
                  // 将tab的子级扁平化,用于部分组件配置项查找对应组件的默认配置
                  _this37.tabListFlat = _this37.tabList.reduce(function (prev, cur) {
                    return prev.concat(cur.value);
                  }, []);
                  _this37.filterList.forEach(function (data) {
                    var item = _this37.tabListFlat.find(function (i) {
                      return i.key === data.key;
                    });
                    if (item) {
                      data.widget = item.widget;
                    }
                  });
                  if (changeTab !== false) {
                    _this37.activeTab = _this37.tabList[0].group_key;
                  }
                  resolve();
                case 4:
                  return _context18.a(2);
              }
            }, _callee18);
          }));
          return function (_x7) {
            return _ref10.apply(this, arguments);
          };
        }());
      });
    },
    /**
     * 拆分产品分类组件 方便用户选择
     * @param data widget总数据
     * @param group_key 要拆分的组件所在分组key
     * @param key 要拆分的组件key
     * @param value_cb 非必传，根据不同组件情况 重置单独属性
     */
    splitGroup: function splitGroup(data, group_key, key, value_cb) {
      var _groupData$value;
      var groupData = data.find(function (i) {
        return i.group_key === group_key;
      });
      var value_index = groupData === null || groupData === void 0 ? void 0 : (_groupData$value = groupData.value) === null || _groupData$value === void 0 ? void 0 : _groupData$value.findIndex(function (i) {
        return i.key === key;
      });
      if (value_index > -1) {
        var _child$config_default;
        // 将每个样式逐一放出来，方便用户快速选择样式
        var child = groupData.value[value_index];
        var typeList = ((_child$config_default = child.config_default_value) === null || _child$config_default === void 0 ? void 0 : _child$config_default.typeList) || child.config_default_value;
        if (Array.isArray(typeList) && typeList.length) {
          var _groupData$value2;
          var split_value = typeList.map(function (item) {
            return _objectSpread(_objectSpread({}, child), {}, {
              widget: child.widget,
              // 组件名称 右侧配置区固定用该属性，左侧组件列表优先取widget_alias 未单独设置 则取默认的该属性
              widget_alias: "".concat(child.widget, "\uFF08").concat(item.title, "\uFF09"),
              // 左侧组件列表要显示的可自定义的组件名
              show_type: item.id,
              icon: item.imageurl
            }, typeof value_cb === 'function' ? value_cb(child, item) : {});
          });
          (_groupData$value2 = groupData.value).splice.apply(_groupData$value2, [value_index, 1].concat(_toConsumableArray(split_value)));
        }
      }
    },
    handleStartRemove: function handleStartRemove(e) {
      this.startX = e.originalEvent.screenX;
    },
    // 移出区域删除板块  end 减去 start位置 大于宽度的一半进行删除
    handleEndRemove: function handleEndRemove(e) {
      if (Math.abs(e.originalEvent.screenX - this.startX) > 315 / 2) {
        var _this$$refs$phone;
        var newIndex = e.newIndex;
        var data = this.layoutList[newIndex];
        data.key === this.configData.key && this.closeConfigPanel();
        this.layoutList.splice(newIndex, 1);
        // 采用此种方法删除板块会导致屏幕首次点击无效,临时解决方案,替用户进行首次点击
        (_this$$refs$phone = this.$refs.phone) === null || _this$$refs$phone === void 0 ? void 0 : _this$$refs$phone.click();
      }
    },
    /**
     * 获取右侧配置项所需菜单列表
     */
    getMenuList: function getMenuList() {
      var _this38 = this;
      /**
       * status === 0 正常状态
       * 菜单状态为隐藏或删除时 添加disabled属性
       * falg : 一级状态为删除或隐藏时,子级同步全部置灰
       */
      var _addDisableProperty = function addDisableProperty(obj, flag) {
        var id = obj.id.split(':')[1] || '';
        obj.disabled = flag || obj.status !== 0 && obj.status !== 1;
        obj.show_name = "".concat(obj.name).concat(id ? "ID".concat(id) : '').concat(obj.alias_name ? "\uFF08".concat(obj.alias_name, "\uFF09") : '');
        if (Array.isArray(obj.childrens)) {
          obj.childrens = obj.childrens.map(function (child) {
            return _addDisableProperty(child, obj.disabled);
          });
        }
        return obj;
      };
      var module = this.info.module;
      getCategory({
        styleId: this.style_id
      }, module).then(function (res) {
        _this38.menuList = res.data.map(function (item) {
          return _addDisableProperty(item);
        });
      });
    },
    // 添加默认底部导航组件
    addBottom: function addBottom(bottom_key) {
      var _this39 = this;
      var bottomIndex = this.layoutList.findIndex(function (i) {
        return i.key === bottom_key;
      });
      if (bottomIndex !== -1) {
        var _this$layoutList$spli = this.layoutList.splice(bottomIndex, 1),
          _this$layoutList$spli2 = _slicedToArray(_this$layoutList$spli, 1),
          originalBottom = _this$layoutList$spli2[0];
        this.bottomData = originalBottom;
        // 获取bottom导航组件所占高度
        this.$nextTick(function () {
          _this39.bottomHeight = _this39.$refs.bottomRef ? _this39.$refs.bottomRef.$el.offsetHeight + 'px' : '0px';
        });
        return;
      }
      var bottom = this.tabListFlat.find(function (i) {
        return i.key === bottom_key;
      });
      if (bottom === undefined) {
        this.bottomHeight = '0px';
        return;
      }
      // 写入底部导航组件默认数据
      var _this$info5 = this.info,
        category_id = _this$info5.category_id,
        menu = _this$info5.menu;
      var data = _objectSpread(_objectSpread({}, JSON.parse(JSON.stringify(bottom))), {}, {
        uid: guid(),
        config: {
          value: bottom.config_default_value.value.map(function (i) {
            return _objectSpread(_objectSpread(_objectSpread({}, i), i.type === 'category' ? bottom.config_default_value.menus_page : {}), category_id && i.type === 'category_home' ? {
              name_alias: "".concat(menu, "\u9996\u9875")
            } : {});
          })
        }
      });
      this.saveConfig(data);
      this.bottomData = data; // 获取bottom导航组件所占高度
      // 获取bottom导航组件所占高度
      this.$nextTick(function () {
        _this39.bottomHeight = _this39.$refs.bottomRef ? _this39.$refs.bottomRef.$el.offsetHeight + 'px' : '0px';
      });
    },
    remoteMethod: function remoteMethod(val) {
      this.$store.dispatch('user/getCompanyList', {
        val: val
      });
    },
    // 初始化
    init: function init() {
      var _arguments2 = arguments,
        _this40 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        var params, queryInfo, _this40$info, temp_id, category_id, _yield$_this40$getHom, _yield$_this40$getHom2, floor, _yield$_this40$getHom3, background_config, style_id, home_style, is_channel, positionData, back_button_show, isNew, data, key, bottom_data;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              params = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
              _this40.closeConfigPanel();
              /* 顺序不可更改 start */
              if (!isEmpty(_this40.propInfo)) {
                _context19.n = 2;
                break;
              }
              _context19.n = 1;
              return _this40.getQueryInfo();
            case 1:
              queryInfo = _context19.v;
              // 获取渠道ID等路由信息供后续使用
              _this40.info = queryInfo;
              _context19.n = 3;
              break;
            case 2:
              _this40.info = _this40.propInfo;
            case 3:
              _this40$info = _this40.info, temp_id = _this40$info.temp_id, category_id = _this40$info.category_id;
              if (temp_id && !['cur', 'new'].includes(temp_id)) {
                _this40.template_config_id = temp_id;
              } else {
                _this40.template_config_id = '';
              }
              if (params.hasOwnProperty('template_config_id')) {
                _this40.template_config_id = params.template_config_id;
                delete params.template_config_id;
              }
              _context19.n = 4;
              return _this40.getHomeData({
                // 初次调用时 在home中传递模板ID 背景设置配置项 后端取该模板的背景设置,不传则取该客户|渠道的背景设置
                template_config_id: _this40.template_config_id
              });
            case 4:
              _yield$_this40$getHom = _context19.v;
              _yield$_this40$getHom2 = _yield$_this40$getHom.floor;
              floor = _yield$_this40$getHom2 === void 0 ? [] : _yield$_this40$getHom2;
              _yield$_this40$getHom3 = _yield$_this40$getHom.background_config;
              background_config = _yield$_this40$getHom3 === void 0 ? {} : _yield$_this40$getHom3;
              style_id = _yield$_this40$getHom.style_id;
              home_style = _yield$_this40$getHom.home_style;
              is_channel = _yield$_this40$getHom.is_channel;
              // 获取主数据 拿到style_id 供获取菜单列表接口使用
              // 如果选择模板不是完全新装修的话 回写楼层数据
              if (_this40.info.temp_id === 'new') {
                _this40.layoutList = [];
                _this40.bottomData = {};
              } else {
                _this40.layoutList = floor.map(function (i) {
                  return _objectSpread(_objectSpread(_objectSpread({}, i), {}, {
                    uid: guid()
                  }, i.key === 'basic_search_shop' ? {
                    key_pointer: 'aggregate_search_shop' // key指向aggregate_search_shop 预览区&配置区均采用该模块}
                  } : {}), ['icon', 'super_nav'].includes(i.key) ? {
                    dialogFormValid: true // 已保存的金刚区数据 分类表单弹窗校验设为通过
                  } : {});
                });
              }
              _this40.background_config = background_config;
              _this40.style_id = style_id;
              _this40.home_style = home_style;
              _this40.is_channel = is_channel;
              _this40.getMenuList(); // 获取多个右侧配置项所需的菜单列表
              _this40.getChildrenMenu(); // 获取多个右侧配置项所需的子页面菜单列表
              _context19.n = 5;
              return _this40.getLeftPanel(params);
            case 5:
              _context19.n = 6;
              return _this40.loadBorderData(_this40.style_id);
            case 6:
              _this40.borderData = _context19.v;
              // mixin中 获取边框圆角属性
              positionData = _this40.layoutList.find(function (i) {
                return i.key === 'position';
              });
              if (positionData) {
                back_button_show = Boolean(positionData.config.back_button_show && category_id);
                _this40.$set(positionData, 'config', _objectSpread(_objectSpread({}, positionData.config), {}, {
                  back_button_show: back_button_show // 首页禁止开启返回按钮 产品要求 如使用模板库中已开启返回按钮的模板 则强制关闭
                }));
                _this40.saveConfig(positionData);
              }
              isNew = _this40.layoutList.length === 0; // 是否为新页面装修
              if (isNew) {
                // 新页面预置顶部组合套件
                data = _this40.tabListFlat.find(function (i) {
                  return i.key === 'box_position_search_switch';
                });
                data && _this40.addBox(data);
              }
              if (!category_id) {
                _context19.n = 7;
                break;
              }
              /**
               * 因二级首页中的底部导航可删除 如果是全新装修页面预置底部导航组件 否则不预置
               * 如果是数据中有底部导航的话 需要回显
               *  */
              key = 'bottom';
              bottom_data = _this40.layoutList.find(function (i) {
                return i.key === key;
              });
              if (isNew || bottom_data) {
                _this40.addBottom(key);
              }
              return _context19.a(2);
            case 7:
              _this40.addBottom('bottom'); // 添加首页默认底部导航组件
              /* 顺序不可更改 */
            case 8:
              return _context19.a(2);
          }
        }, _callee19);
      }))();
    },
    getConfigList: function getConfigList() {
      var _this41 = this;
      var _this$info6 = this.info,
        module = _this$info6.module,
        customer_id = _this$info6.customer_id;
      var isCustomer = ['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module);
      getSystemMenus({}, module).then(function (res) {
        _this41.systemMenus = res.data;
      });
      // 获取礼包方案下拉数据
      getCustomerPackage({
        customer_id: customer_id,
        only_promotion: Number(!isCustomer) //是否只显示促销礼包方案  0或不传-否（客户级）；1-是（渠道级）
      }).then(function (res) {
        _this41.customerPackageList = res.data;
      });
      if (isCustomer) {
        // 获取SaaS板块下拉数据
        getUnionModule({
          customer_id: customer_id
        }, module).then(function (res) {
          _this41.customerModuleList = res.data;
        });
        getBookCategoryList({
          customer_id: customer_id,
          book_type: 1
        }).then(function (res) {
          _this41.eBookCategoryList = res.data.list || [];
        });
        getBookCategoryList({
          customer_id: customer_id,
          book_type: 2
        }).then(function (res) {
          _this41.aBookCategoryList = res.data.list || [];
        });
      }
    },
    // 获取图片上传类型等
    getUploadInfo: function getUploadInfo() {
      var _this42 = this;
      getFileInfo().then(function (res) {
        _this42.uploadInfo = res.data;
      });
    }
  },
  mounted: function mounted() {
    var _this43 = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
      var _this43$info, menu, module;
      return _regenerator().w(function (_context20) {
        while (1) switch (_context20.n) {
          case 0:
            _this43.getUploadInfo(); // 获取图片上传类型等
            _context20.n = 1;
            return _this43.init();
          case 1:
            _this43.getConfigList();
            _this43$info = _this43.info, menu = _this43$info.menu, module = _this43$info.module;
            if (!_this43.disabled) {
              _context20.n = 2;
              break;
            }
            return _context20.a(2);
          case 2:
            if (menu == '电影' && ['plat_custom', 'service_custom', 'custom', 'plat_service_custom'].includes(module)) {
              _this43.showBanner = true;
              movieBanner(_objectSpread({}, _this43.bannerParams), 'get', module).then(function (res) {
                if (res.data.data.length) {
                  _this43.bannerParams.data = res.data.data;
                }
              });
            }
          case 3:
            return _context20.a(2);
        }
      }, _callee20);
    }))();
  },
  computed: {
    // 客户级功能菜单装修才展示通知消息页签，由通知消息保存权限控制
    canShowNoticeTab: function canShowNoticeTab() {
      return !!this.info.category_id && this.info.category_id !== '0' && this.info.module === 'custom' && this.$hasBtnRoles('/decoration/decoration/save-category-page-notice-by-customer');
    },
    canSaveThumb: function canSaveThumb() {
      var _this$info7 = this.info,
        category_id = _this$info7.category_id,
        module = _this$info7.module;
      if (category_id) {
        return this.$hasBtnRoles({
          admin: '/decoration/decoration/loogthumb-by-category',
          custom: '/decoration/decoration/loogthumb-by-category-customer',
          plat_custom: '/plat/decoration/loogthumb-by-category-customer',
          channel: '/decoration/decoration/loogthumb-current-by-category'
        }[module]);
      } else {
        return this.$hasBtnRoles({
          admin: '/decoration/decoration/loogthumb-by-home',
          custom: '/decoration/decoration/loogthumb-by-customer',
          plat_custom: '/plat/decoration/loogthumb-by-customer',
          channel: '/decoration/decoration/loogthumb-current-by-home'
        }[module]);
      }
    },
    sellUserList: function sellUserList() {
      return this.$store.state.user.sellUsersList;
    },
    topLastIndex: function topLastIndex() {
      var _this44 = this;
      return this.allLayoutList.findLastIndex(function (i) {
        return _this44.topDisableList.includes(i.key);
      });
    },
    // 找到禁止往顶部元素添加的最后一个元素下标位置
    // 支持拖拽的元素数据 & 不支持拖拽的底部导航组件 集合
    // 将bottom导航组件单提出来是因为 放在layoutList里时,有时会因为移动组件顺序,莫名将底部导航顶上去了
    allLayoutList: function allLayoutList() {
      return this.layoutList.concat(isEmpty(this.bottomData) ? [] : this.bottomData);
    },
    // 已经满足列表中有一个的组件
    leftFilterDomList: function leftFilterDomList() {
      var _this45 = this;
      return this.filterList.filter(function (item) {
        return item.isShow(_this45.allLayoutList);
      }).map(function (i) {
        return i.key;
      });
    },
    companyList: function companyList() {
      return this.$store.state.user.companyList;
    },
    dynamicStyle: function dynamicStyle() {
      var _this46 = this;
      var _this$background_conf = this.background_config,
        background_type = _this$background_conf.background_type,
        solid_color_background = _this$background_conf.solid_color_background,
        top_background = _this$background_conf.top_background,
        middle_background = _this$background_conf.middle_background,
        bottom_background = _this$background_conf.bottom_background;
      var _this$borderData = this.borderData,
        _this$borderData$brod = _this$borderData.broder_general,
        broder_general = _this$borderData$brod === void 0 ? 10 : _this$borderData$brod,
        _this$borderData$brod2 = _this$borderData.broder_left_top,
        broder_left_top = _this$borderData$brod2 === void 0 ? 10 : _this$borderData$brod2,
        _this$borderData$brod3 = _this$borderData.broder_right_top,
        broder_right_top = _this$borderData$brod3 === void 0 ? 10 : _this$borderData$brod3,
        _this$borderData$brod4 = _this$borderData.broder_right_bottom,
        broder_right_bottom = _this$borderData$brod4 === void 0 ? 10 : _this$borderData$brod4,
        _this$borderData$brod5 = _this$borderData.broder_left_bottom,
        broder_left_bottom = _this$borderData$brod5 === void 0 ? 10 : _this$borderData$brod5,
        _this$borderData$type = _this$borderData.type,
        type = _this$borderData$type === void 0 ? 1 : _this$borderData$type;
      var baseSize = 32; //基准值 16*2 C端即可直接取值
      var borderLeftTop = (type === 2 ? broder_left_top : broder_general) / baseSize;
      var borderRightTop = (type === 2 ? broder_right_top : broder_general) / baseSize;
      var borderRightBottom = (type === 2 ? broder_right_bottom : broder_general) / baseSize;
      var borderLeftBottom = (type === 2 ? broder_left_bottom : broder_general) / baseSize;
      return _objectSpread(_objectSpread(_objectSpread({
        '--bottomHeight': this.bottomHeight,
        '--floatLength': this.allLayoutList.filter(function (i) {
          return _this46.topDisableList.includes(i.key);
        }).length
      }, background_type === 1 ? {
        '--topBackground': top_background ? "url(".concat(top_background, ")") : 'none',
        '--middleBackground': "url(".concat(middle_background, ")"),
        '--bottomBackground': bottom_background ? "url(".concat(bottom_background, ")") : 'none'
      } : {}), background_type === 2 ? {
        'background-color': solid_color_background
      } : {}), {}, {
        '--borderRadius': "".concat(borderLeftTop, "rem ").concat(borderRightTop, "rem ").concat(borderRightBottom, "rem ").concat(borderLeftBottom, "rem")
      });
    }
  },
  watch: {
    activeTab: {
      handler: function handler(v, oldVal) {
        this.oldActiveTab = oldVal;
        this.closeConfigPanel();
        var data = this.tabList.find(function (i) {
          return i.group_key === v;
        });
        this.activeLeftData = data;
      },
      immediate: true
    }
  }
};